import { render, staticRenderFns } from "./push-list.vue?vue&type=template&id=30d940d4&scoped=true&"
import script from "./push-list.vue?vue&type=script&lang=js&"
export * from "./push-list.vue?vue&type=script&lang=js&"
import style0 from "./push-list.vue?vue&type=style&index=0&id=30d940d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d940d4",
  null
  
)

export default component.exports